<template>
  <v-avatar :size="size" :color="color">
    <img v-if="workspace.profile.avatarUrl" :src="workspace.profile.avatarUrl" alt="avatar" />
    <img
      v-else-if="showImage"
      :src="`https://picsum.photos/seed/${workspace.id}/${size > 200 ? size : 200}/?blur`"
      :size="size"
    />
    <span v-else>{{ workspace.profile.name[0] }}</span>
  </v-avatar>
</template>

<script>
export default {
  name: 'user-avatar',
  props: {
    size: { default: 30 },
    avatarUrl: { default: false },
    workspace: {
      default: function() {
        return {
          id: '',
          profile: {
            name: '',
            avatarUrl: false
          }
        };
      }
    },
    color: {},
    showImage: { default: false }
  },
  data() {
    return {};
  },
  computed: {}
};
</script>
